(function ($) {

'use strict';

	/**
	 * Initialize the menu click handlers
	 * @returns {undefined}
	 */
	$.initMenuClickHandler = function () {
		/**
		 * Click handler used to close the open menu
		 * @param {Event} e
		 * @returns {undefined}
		 */
		function menuExitClickHandler(e) {
			if ($('.nav-btn').length < 1 &&
					$(e.target).closest('#mainmenu').length === 0) {
				$('#mainmenu li.dropdown').find('a').first().trigger('click');
			}
		}

		function navBtnExitClickHandler(e) {
			if ($(e.target).closest('#mainmenu').length === 0 || $(e.target).attr('id') === 'mainmenu') {
				e.stopPropagation();
				$('.nav-btn').trigger('click');
				return false;
			}
		}

		function menuScroll() {
			var $menu = $('#mainmenu');
			var bottom = $menu.offset().top + $menu.outerHeight();
			if ((bottom - $(window).scrollTop()) < 0) {
				// hide menu
				$('.nav-btn').trigger('click');
			}
		}


		var arrowInitDone = false;
		// remove open/close arrows
		$('#mainmenu a span.menuarrow').remove();
		// reset css display for all ul elements
		$('#mainmenu li ul').css('display', '');
		// hide submenus but not the extra submenus
		$('#mainmenu li:not(.submenu-parent) > ul:visible').each(function () {
			var $mainMenuItem = $(this).closest('li');
			$(this).hide(0);
			// check if there is a submenu item which has the same link as 
			// the current item.
			// if not clone the item as the 1st submenu item
			var menuLink = $mainMenuItem.find('a').first().attr('href');
			if (menuLink !== 'javascript:;' &&
					$(this).find('li a[href="' + menuLink + '"]').length < 1) {

				var $clonedItem = $mainMenuItem.clone();
				$clonedItem.find('ul').remove();
				$clonedItem.find('a').first().addClass('menu-cloned');
				$(this).prepend($clonedItem);
			}
		});

		// mark the active submenu parent
		$('#submenu  li > ul > li.active').closest('li.submenu-parent').addClass('submenu-parent-active');

		/**
		 * Event handler to toggle submenus
		 * @param {event} e
		 * @returns {Boolean}
		 */
		function subMenuToggleHandler(e) {
			var $submenu = $(e.target).closest('li:not(.submenu-parent)').find('ul');
			if ($submenu.length > 0) {
				// hide open submenus, but not the current
				$('#mainmenu li:not(.submenu-parent) ul').not($submenu).hide();
				$('#mainmenu li').removeClass('dropdown');
				$('#mainmenu li .menuarrow').html($.morejs_options.sandwichMenu.closedSubMenuArrow);

				var doneFunc = function () {
					// change menu arrow
					var isVisible = $submenu.is(':visible');
					$submenu.closest('li').find('a span.menuarrow')
							.html(isVisible
									? $.morejs_options.sandwichMenu.openedSubMenuArrow
									: $.morejs_options.sandwichMenu.closedSubMenuArrow);
					if (isVisible) {
						$submenu.closest('li').addClass('dropdown');
						// close langmenu if active
						$('.language.active').trigger('click');
					}
					if ($('#mainmenu').length > 0) {
						// all existing click handlers has to be removed for the language menu
						$(document).off('click.menuexit');
						if ($submenu.is(':visible')) {
							$(document).on('click.menuexit', menuExitClickHandler);
						}
					}
				};

				if ($submenu.is(':visible')) {
					$submenu.slideUp({
						duration: 100,
						done: doneFunc
					});
				} else {
					$submenu.slideDown({
						duration: 100,
						done: doneFunc
					});
				}
				return false;
			}
			return true;
		}

		// set toggle click handler for menu links without href target
		$('#mainmenu a[href="javascript:;"]').off('click.submenutoggle').on('click.submenutoggle', subMenuToggleHandler);

		// breadcrumb handling. Trigger click for a.bc-menutitle if it has the same text as the active main menu entry
		var $bcMain = $('#breadcrumb li.bc-menutitle a');
		var $activeMainMenu = $('#mainmenu > li.active > a').first();
		if ($bcMain.length > 0 && $activeMainMenu.length > 0 &&
				$bcMain.attr('href') === 'javascript:;' &&
				$bcMain.text() === $activeMainMenu.text()) {

			$bcMain.off('click.bcclick').on('click.bcclick', function () {
				if (!$(this).siblings('ul').first().is(':visible')) {
					$activeMainMenu.trigger('click');
				}
				if (!$('.nav-btn + ul#mainmenu').is(':visible')) {
					$('.nav-btn').trigger('click');
				}
			});
		}

		// set click handler for the sandwich menubutton
		$('.nav-btn').off('click.navbtn').on('click.navbtn', function () {
			// init open/close arrows
			if (!arrowInitDone) {
				$('#mainmenu li:not(.submenu-parent) > ul').each(function () {
					var $mainMenuItem = $(this).closest('li');
					$mainMenuItem.find('a').first()
							.append('<span aria-hidden="true" class="menuarrow">' +
									($(this).is(':visible')
											? $.morejs_options.sandwichMenu.openedSubMenuArrow
											: $.morejs_options.sandwichMenu.closedSubMenuArrow) +
									'</span>');
				});
				arrowInitDone = true;
			}

			var $menus = $('#mainmenu');
			var menuZindexOri = $menus.css('z-index');

			// toogle the menu and trigger event to open the active submenu
			if (!$menus.is(':visible')) {
				$('html, body').stop().animate({scrollTop: 0},
						{
							duration: 100,
							complete: function () {
								$(window).off('scroll.menuscroll').on('scroll.menuscroll', menuScroll);
								$(document).off('click.navbtnexit').on('click.navbtnexit', navBtnExitClickHandler);
								$menus.css('z-index', '20000');

								// call the onOpen function if defined
								if (typeof $.morejs_options.sandwichMenu.onOpen === 'function') {
									$.morejs_options.sandwichMenu.onOpen();
								}

							}
						});

			} else {
				$(window).off('scroll.menuscroll');
				$(document).off('click.navbtnexit');
				$('.nav-btn').show();
				$menus.css('z-index', menuZindexOri);

				// call the onClose function if defined
				if (typeof $.morejs_options.sandwichMenu.onClose === 'function') {
					$.morejs_options.sandwichMenu.onClose();
				}
			}
			$menus.toggle({
				duration: 100,
				done: function () {
					//$('body').prepend(
					$('#mainmenu li.active ul').show();
					$('#mainmenu li.active .menuarrow').html($.morejs_options.sandwichMenu.openedSubMenuArrow);
					
					// restore menu styling when closed
					if(!$menus.is(':visible')){
						$menus.removeAttr('style');
					}
				}
			});

			// click handler for submenus
			$('#mainmenu li:not(.submenu-parent) > a:not(#searchlink)').off('click.submenutoggle').on('click.submenutoggle', subMenuToggleHandler);

			return false;
		});


		// language menu

		/**
		 * Click handler for language menu
		 */
		var $langMenu = $('#langmenu');
		if ($langMenu.closest('nav').find('.nav-btn').length < 1) {

			$langMenu.off('click.langmenu').on('click.langmenu', function (e) {

				/**
				 * Hide the languages element
				 * @param {Event} e
				 * @returns {undefined}
				 */
				function langMenuHide(e) {
					if ($('.nav-btn').length < 1 &&
							$(e.target).closest('#langmenu').length < 1) {

						if ($('.language').is(':visible')) {
							$langMenu.trigger('click');
						} else {
							$(window).off('click.langmenuhide');
						}
					}
				}

				var $languages = $(this).siblings('ul.language');
				if ($languages.hasClass('active')) {
					$languages.slideUp({
						duration: 100,
						done: function () {
							$languages.removeClass('active');
						}
					});
					$(this).removeClass('menuOpen');
					$(window).off('click.langmenuhide');
				} else {
					$(this).addClass('menuOpen');
					// hide opened submenu
					if ($(e.target).closest('li.dropdown').length < 1) {
						$('#mainmenu li.dropdown a').trigger('click');
					}

					$languages.slideDown({
						duration: 100,
						done: function () {
							$languages.addClass('active');
						}
					});
					$(window).off('click.langmenuhide').on('click.langmenuhide', langMenuHide);
				}
				return false;
			});
		}
	}; // initMenuClickHandler	

}(jQuery));